const initialValues = {

    imageFile: null,
    imageUrl: "",
    title: "",
    company: "",
    productYear: "",
    kilometer: "", 
    distancePerWeek: "", 
    useFuel: "", 
    pelak1: "", 
    pelak2: 1, 
    pelak3: "", 
    pelak4: "",
    shasiNo: "",
    userId: null,
  };
  
  export default initialValues;